import styled from 'styled-components';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import { ParagraphSmallText } from '../../../components/Texts';
import { formatDate } from '../../../common/date';

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
  height: fit-content;
  margin-top: -10px;
  margin-bottom: -10px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  height: fit-content;
  color: ${({ theme }) => theme.text.regular};
`;

const Tbody = styled.tbody``;

const Tr = styled.tr`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  @media ${PHONE_MEDIA_QUERY} {
    padding: 12px;
  }
`;

const Td = styled.td`
  padding: 16px;
  vertical-align: middle;
  border-bottom: 1px solid ${({ theme }) => theme.border.secondary};
  font-size: 14px;
`;

const TYPE_MAPPING = {
  TRANSACTION_FEE: 'Transaction Fee',
  FIAT_DEPOSIT: 'First Deposit',
};

const STATUS_MAPPING = {
  PENDING: 'Pending',
  PAID: 'Paid',
};

const Status = styled.div`
  background-color: ${({ theme }) => theme.primary.background};
  border: 1px solid ${({ theme }) => theme.primary.ultraLight};
  color: ${({ theme }) => theme.primary.primary};
  padding: 6px 10px;
  border-radius: 8px;
  width: fit-content;
  ${({ status, theme }) =>
    status === 'PENDING' &&
    `
    background-color: ${theme.status.warning.background};
    border: 1px solid ${theme.status.warning.background};
    color: ${theme.status.warning.primary};
  `}
`;

const Amount = styled.div`
  color: ${({ theme }) => theme.status.success.primary};
  font-weight: 600;
`;

const Row = ({ reward }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <Tr key={reward.id}>
      <Td>
        <Status status={reward.status}>
          <p>{STATUS_MAPPING[reward.status]}</p>
        </Status>
      </Td>
      {!isMobile && (
        <>
          <Td>
            <div>
              <p>{TYPE_MAPPING[reward.operationType]}</p>
            </div>
          </Td>
          <Td>
            <div>
              <p>{reward.currency}</p>
            </div>
          </Td>
        </>
      )}
      <Td>
        <Amount>
          <p>+{reward.amount}</p>
        </Amount>
      </Td>
      {!isMobile && (
        <Td>
          <div>
            <p>{formatDate(new Date(reward.createdAt))}</p>
          </div>
        </Td>
      )}
    </Tr>
  );
};

const RewardsTable = ({ data }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <TableContainer>
      <Table>
        <thead>
          <Tr>
            <Td>Status</Td>
            {!isMobile && <Td>Type</Td>}
            {!isMobile && <Td>Payment Currency</Td>}
            <Td>Amount</Td>
            {!isMobile && <Td>Date</Td>}
          </Tr>
        </thead>
        <Tbody>
          {data.map((reward, i) => {
            return <Row key={`${reward.id}-${i}`} reward={reward} />;
          })}
          {data.length === 0 && (
            <Tr>
              <Td
                colSpan={isMobile ? 3 : 6}
                style={{ textAlign: 'center', padding: '20px' }}
              >
                <ParagraphSmallText>No rewards yet</ParagraphSmallText>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default RewardsTable;
